export const language = process.env.GATSBY_LEGAL_LANGUAGE
export const PARTNER_SHORT_NAME = process.env.GATSBY_LEGAL_PARTNER_SHORT_NAME
export const PARTNER_COMPANY_NAME =
  process.env.GATSBY_LEGAL_PARTNER_COMPANY_NAME
export const PARTNER_VAT = process.env.GATSBY_LEGAL_PARTNER_VAT
export const PARTNER_SUPPORT_EMAIL =
  process.env.GATSBY_LEGAL_PARTNER_SUPPORT_EMAIL
export const PARTNER_DATA_PROCESSORS =
  process.env.GATSBY_LEGAL_PARTNER_DATA_PROCESSORS
export const PARTNER_PARTNERS = process.env.GATSBY_LEGAL_PARTNER_PARTNERS
export const LEGAL_VERSION_TERMS = process.env.GATSBY_LEGAL_TERMS_VERSION
export const LEGAL_LAST_UPDATED_TERMS =
  process.env.GATSBY_LEGAL_TERMS_LAST_UPDATED
export const LEGAL_VERSION_PRIVACY = process.env.GATSBY_PRIVACY_TERMS_VERSION
export const LEGAL_LAST_UPDATED_PRIVACY =
  process.env.GATSBY_PRIVACY_TERMS_LAST_UPDATED
export const LEGAL_VERSION_MARKETING =
  process.env.GATSBY_MARKETING_TERMS_VERSION
export const LEGAL_LAST_UPDATED_MARKETING =
  process.env.GATSBY_MARKETING_TERMS_LAST_UPDATED
export const LEGAL_CONTACT_INFO = process.env.GATSBY_LEGAL_CONTACT_INFO

export const concatBundleToString = (
  bundle: string | undefined,
  splitOperator: "::" | "-:-",
  newLineString: "\n" | "\n\n"
) => {
  let processorString = ""
  if (!bundle) {
    return processorString
  }
  const processors = bundle.split(splitOperator)
  for (let i = 0; i < processors.length; i++) {
    processorString += `${processors[i]}` + newLineString
  }
  return processorString
}

export const concatDoubleBundleToString = (bundle: string | undefined) => {
  let processorString = ""
  if (!bundle) {
    return processorString
  }
  const processors = bundle.split("::")
  for (let i = 0; i < processors.length; i++) {
    processorString += `${concatBundleToString(processors[i], "-:-", "\n")}\n`
  }
  return processorString
}
